import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { IDateType } from '../Types';

export interface ISelectiveProcess {
  id: string;
  name: string;
  registrations_start: IDateType;
  registrations_end: IDateType;
  exemption_start: IDateType;
  has_pcd: boolean;
  has_black_or_brown: boolean;
  exemption_end: IDateType;
  number_of_vacancies: number;
  public_notice_number: string;
  selective_process_situation: ISelectiveProcessSituation[];
  type: string;
  for_testing_only: boolean;
  created_at: IDateType;
}

export interface ISelectiveProcessSituation {
  id: string;
  name: string;
}

const RequestSelectiveProcess = async (filter: string = '', finalSearch: string = '', rp?: boolean) => {
  const response = await configApi.get<ISelectiveProcess[] | { results: ISelectiveProcess[] }>(
    `candidate-area/selective-process/`,
    {
      params: {
        status: filter,
        name: finalSearch,
        remove_pagination: rp,
      },
    },
  );
  const data = response.data;
  return Array.isArray(data) ? data : (data?.results ?? []);
};

export const useRequestSelectiveProcess = (filter?: string, finalSearch?: string, rp?: boolean) => {
  return useQuery({
    queryKey: ['selective_process', filter, finalSearch],
    queryFn: () => RequestSelectiveProcess(filter, finalSearch, rp),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
